import { render, staticRenderFns } from "./numericBox.vue?vue&type=template&id=3dbea22e&"
import script from "./numericBox.vue?vue&type=script&lang=ts&"
export * from "./numericBox.vue?vue&type=script&lang=ts&"
import style0 from "./numericBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports